import { Dispatch, createSlice } from "@reduxjs/toolkit";
import { TRequestStatus } from "@models/msc.model";
import teamsService from "@/services/teams.service";
import { RootState } from "..";
import { TTeam } from "@/models/teams.model";

type TeamsState = {
  initialized: boolean;
  status: TRequestStatus;
  teams: TTeam[];
};

//-----THUNK FUNCTIONS-----

const initialState: TeamsState = {
  initialized: false,
  status: "IDLE",
  teams: [],
};

const teamsSlice = createSlice({
  name: "teams",
  initialState,
  reducers: {
    startLoading(state) {
      state.status = "PENDING";
    },
    rollback(state, actions) {
      state.status = "IDLE";
      state.teams = actions.payload;
    },
    gotTeams(state, action) {
      state.teams = action.payload;
      state.status = "IDLE";
      state.initialized = true;
    },
    teamSaved(state, action) {
      state.teams.push(action.payload);
    },
    teamUpdated(state, action) {
      state.teams = state.teams.map((t) => (t.id === action.payload.id ? action.payload : t));
    },
    teamRemoved(state, action) {
      state.teams = state.teams.filter((t) => t.id !== action.payload);
    },
  },
});

// ----------------------------

export const getAllTeams = () => async (dispatch: Dispatch, getState: () => RootState) => {
  const {
    teams: { teams, initialized },
  } = getState();

  if (initialized) return teams;

  dispatch(teamsSlice.actions.startLoading());
  const response = await teamsService.getAll();
  dispatch(teamsSlice.actions.gotTeams(response));
  return response;
};

// ----------------------------

export const saveTeam = (data: TTeam) => async (dispatch: Dispatch) => {
  const response = await teamsService.save(data);
  dispatch(teamsSlice.actions.teamSaved(response));
  return response;
};

// ----------------------------
export const updateTeam = (data: TTeam) => async (dispatch: Dispatch) => {
  await teamsService.update(data);
  dispatch(teamsSlice.actions.teamUpdated(data));
};

// ----------------------------

export const removeTeam = (teamId: number) => async (dispatch: Dispatch, getState: () => RootState) => {
  const { teams } = getState().teams;
  const teamsForRollBack = structuredClone(teams);
  dispatch(teamsSlice.actions.teamRemoved(teamId));

  try {
    await teamsService.removeById(teamId);
  } catch (error) {
    dispatch(teamsSlice.actions.rollback(teamsForRollBack));
    throw error;
  }
};

// ----------------------------

export default teamsSlice.reducer;
